import React from 'react';
import { useTranslation } from 'react-i18next';
import { BILLING_TERMS, BillingTerm, termDiscountPercent } from '../config/pricing';

interface BillingTermSelectorProps {
  value: BillingTerm;
  onChange: (term: BillingTerm) => void;
  containerClassName?: string;
  activeClassName?: string;
}

const BillingTermSelector: React.FC<BillingTermSelectorProps> = ({
  value,
  onChange,
  containerClassName = 'inline-flex items-center bg-gray-100 p-1 rounded-xl',
  activeClassName = 'bg-white text-gray-900 shadow-sm',
}) => {
  const { t } = useTranslation();

  return (
    <div className={containerClassName} role="radiogroup" aria-label={t('pricingTerms.title')}>
      {BILLING_TERMS.map((term) => {
        const discount = termDiscountPercent(term.key);
        const active = value === term.key;
        return (
          <button
            key={term.key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(term.key)}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all flex items-center gap-2 ${
              active ? activeClassName : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {t(`pricingTerms.${term.key}`)}
            {discount > 0 && (
              <span className="text-[10px] bg-green-100 text-green-700 px-2 py-0.5 rounded-full uppercase tracking-wider font-bold">
                {t('pricingTerms.save', { percent: discount })}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BillingTermSelector;
